import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import {
    DtGroup,
    DtCmfContainer,
    DtCmfImage,
    DtBlock,
    DtRow,
    DtName,
    DtLink,
    FilterInput,
    FilterLabel,
    DocumentTypesTitle,
    TableDataContainer,
    DocTypesAndPaginationContainer,
    FilterAreaContainer,
    FilterContainer,
    ImpactAreaFilter,
    DtTitleWithoutLink
} from './DocumentTypesGrid.styles';
import { grayDark03 } from '../../../../styles/colors';
import CustomPagination from '../../../common/pagination/CustomPagination';
import { ImpactAreas } from '../../../../types/impactAreas/impactAreas.enum';
import { SustainabilityDocument } from '../../../../redux/actions/productActions/types';

interface Props {
    totalCount: number;
    totalWithFilterCount: number;
    documentTypes: Array<SustainabilityDocument>;
    getDocumentTypes: (page: number, searchString: string, impactArea?: string) => void;
}

const DocumentTypesGrid: React.FC<Props> = ({
    totalCount,
    totalWithFilterCount,
    documentTypes,
    getDocumentTypes
}) => {
    const [state, setState] = useState({ searchString: '', curPage: 1 });
    const [selectedImpactArea, setSelectedImpactArea] = useState<string>(ImpactAreas.AllImpactAreas);

    const impactAreaFilters: string[] = Object.values(ImpactAreas) as string[];

    useEffect(() => {
        if (totalCount < 10) {
            setState({ ...state, curPage: 1 });
        }
    }, [totalCount]);

    const changePage = (page: number) => {
        setState({ ...state, curPage: page });
        getDocumentTypes(page, state.searchString, selectedImpactArea);

    };

    const handleCurrentPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currentCount = event.currentTarget.value;
        if (/^-?\d*\.?\d*$/.test(currentCount) || currentCount === '') {
            setState({ ...state, curPage: +event.currentTarget.value });
        }
        if (+currentCount > Math.ceil(totalWithFilterCount / 10)) {
            setTimeout(() => {
                setState({
                    ...state,
                    curPage: Math.ceil(totalWithFilterCount / 10),
                });
            }, 1000);
        }
        if (
            +event.currentTarget.value > 0 &&
            +event.currentTarget.value <= Math.ceil(totalWithFilterCount / 10)
        ) {
            getDocumentTypes(+event.currentTarget.value, state.searchString, selectedImpactArea);
        }
        if (+currentCount === 0) {
            getDocumentTypes(1, state.searchString, selectedImpactArea);
            setTimeout(() => {
                setState({
                    ...state,
                    curPage: 1,
                });
            }, 1000);
        }
    };

    const handleFilterPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        getDocumentTypes(state.curPage, event.target.value, selectedImpactArea);
        setState({ ...state, searchString: event.target.value });
    };

    const handleImpactAreaChange = (impactArea: string) => {
        setSelectedImpactArea(impactArea);
        getDocumentTypes(state.curPage, state.searchString, impactArea);
    }

    return (
        <>
            {(() => { debugger; return null; })()}
            <TableDataContainer>
                    <DocTypesAndPaginationContainer>
                        <DocumentTypesTitle>Document types ({totalCount})</DocumentTypesTitle>

                        <CustomPagination
                            page={state.curPage}
                            total={totalWithFilterCount}
                            pageSize={10}
                            changePageNumber={changePage}
                            handleCurrentPage={handleCurrentPage}
                        />
                    </DocTypesAndPaginationContainer>
                    <FilterAreaContainer>
                        <FilterContainer>
                            <FilterLabel weight={400} size={12} height={12} color={grayDark03}>
                                Impact area
                            </FilterLabel>
                            <ImpactAreaFilter
                                options={impactAreaFilters.map((filter) => ({label: filter, value: filter}))}
                                style={{
                                    width: 175+'px',
                                    height: 28+'px'
                                }}
                                suffixIcon={
                                    <Image
                                        src="src/assets/images/ic-dropdown-arrow.svg"
                                        preview={false}
                                        alt="caret-down"
                                    />
                                }
                                defaultValue={ImpactAreas.AllImpactAreas}
                                onChange={handleImpactAreaChange}
                            >
                            </ImpactAreaFilter>
                        </FilterContainer>
                        <FilterContainer>
                            <FilterLabel weight={400} size={12} height={12} color={grayDark03}>
                                Filter
                            </FilterLabel>
                            <FilterInput width={164} height={28} onChange={handleFilterPage} placeholder='Document type' />
                        </FilterContainer>
                    </FilterAreaContainer>
            </TableDataContainer>

         {documentTypes.length && documentTypes.length > 0 ? (
          <DtGroup>
              {documentTypes?.map((dt) => (
                <DtBlock>
                   <DtRow height={dt.title.length < 69 ? 32 : 52}>
                     <DtName>
                        {dt.certificationUrl ? (
                            <DtLink href={dt.certificationUrl} target="_blank">
                                {dt.title}
                            </DtLink>
                        ) : (
                            <DtTitleWithoutLink>{dt.title}</DtTitleWithoutLink>
                        )}

                     </DtName>
                     <DtCmfContainer>
                       {dt.impactAreas && dt.impactAreas.length > 0 && dt.impactAreas[0].id > 0 && (
                        <>
                        {dt?.impactAreas?.map((impactArea) => (
                          <DtCmfImage>
                             <Image
                                preview={false}
                                src={impactArea.iconSmallUrl}
                                style={{ cursor: 'pointer' }}
                                title={impactArea.title}
                                width={17} height={17}
                             />
                          </DtCmfImage>
                        ))}
                        </>
                      )}
                     </DtCmfContainer>
                   </DtRow>
                </DtBlock>
              ))}
          </DtGroup>
          ) : (<></>)
        }

        </>
    );
};

export default DocumentTypesGrid;
